export type StatusItem = {
  value: string;
  className?: string; // Optional custom styling for specific items
};

type StatusBarProps = {
  items: StatusItem[];
  className?: string; // Optional custom styling for the entire bar
};

export default function StatusBar({items, className}: StatusBarProps) {
  // Don't render if no items
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 right-0 bg-gray-800 text-white text-xs px-3 py-1 rounded-tl-md z-50 flex gap-4 ${className || ''}`}
    >
      {items.map(({value, className: itemClassName}, index) => (
        <span key={index} className={itemClassName}>
          <span className="font-medium">{value}</span>
        </span>
      ))}
    </div>
  );
}
